import { useEffect, useState } from 'react';

import useSWR from 'swr';

import { getWorkloadNamespaces } from '../api';
import { WorkloadFetch } from '../constants';

export function useAllNamespaces(cluster: string, enabled = true) {
  const [data, setData] = useState([]);
  const {
    data: response,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(enabled && cluster ? { key: WorkloadFetch.NAMESPACES, cluster, pathname: window.location.pathname } : null, ({ cluster }) =>
    getWorkloadNamespaces(cluster),
  );

  useEffect(() => {
    if (response) {
      setData(response);
    }
  }, [response]);

  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  };
}
